import { css } from 'emotion';
import * as React from 'react';

interface ISmallInputProps {
  className?: string;
  name?: string;
  value?: string;
  errorValue?: string;
  maxLength?: number;
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
}

const main = (className: string) => css`
  width: 100%;
  height: 33px;
  font-family: 'Nunito', sans-serif;
  font-size: 14px;
  border: solid 1px #bfbcbc;
  border-radius: 25px;
  padding-left: 10px;
  outline: none;
  -webkit-appearance: none;

  ${className}
`;

export const SmallInput = ({ name = '', className = '', value = '', maxLength, onChange }: ISmallInputProps) => (
  <input
    className={main(className)}
    placeholder={name}
    onChange={onChange}
    value={value}
    maxLength={maxLength && maxLength}
  />
);
